import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "goods_class"
};
const _hoisted_2 = {
  class: "goods_big"
};
const _hoisted_3 = {
  key: 0,
  class: "goods_show"
};
const _hoisted_4 = {
  class: "goods_txt"
};
const _hoisted_5 = {
  class: "goods_info"
};
const _hoisted_6 = {
  class: "goods_buy"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "cart_btn"
};
const _hoisted_9 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_sidebar_item = _resolveComponent("van-sidebar-item");
  const _component_van_sidebar = _resolveComponent("van-sidebar");
  const _component_van_sticky = _resolveComponent("van-sticky");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_stepper = _resolveComponent("van-stepper");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(() => [_createVNode(_component_van_nav_bar, {
      title: "产品中心"
    }), _createVNode(_component_van_search, {
      modelValue: $setup.keywords,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.keywords = $event),
      placeholder: "请输入搜索关键词",
      onSearch: $setup.goSearch
    }, null, 8, ["modelValue", "onSearch"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_sidebar, {
      modelValue: $setup.active,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.active = $event),
      class: "class_lshow"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.clist, (item, key) => {
        return _openBlock(), _createBlock(_component_van_sidebar_item, {
          title: item.class_name,
          onClick: $event => $setup.ClassSel(item.id)
        }, null, 8, ["title", "onClick"]);
      }), 256))]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }), _createElementVNode("div", _hoisted_2, [$setup.isShow ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[2] || (_cache[2] = $event => $setup.loading = $event),
    finished: $setup.finished,
    "finished-text": "没有更多了",
    onLoad: $setup.loadData
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "goods_list",
        key: key
      }, [_createElementVNode("div", {
        class: "goods_img",
        style: _normalizeStyle("background-image: url(" + item.img + ");")
      }, [_createVNode(_component_router_link, {
        to: "/goods/show?id=" + item.id
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["to"])], 4), _createElementVNode("div", _hoisted_4, [_createElementVNode("dl", _hoisted_5, [_createElementVNode("dt", null, _toDisplayString(item.name), 1), _createElementVNode("dd", null, "规格：" + _toDisplayString(item.spec), 1), _createElementVNode("dd", null, "保质期：" + _toDisplayString(item.quality), 1)]), _createElementVNode("dl", _hoisted_6, [_createElementVNode("dt", null, [_createElementVNode("span", null, "￥" + _toDisplayString(item.price) + "/" + _toDisplayString(item.unit), 1)]), $setup.cartList[item.id] ? (_openBlock(), _createElementBlock("dd", _hoisted_7, [_createVNode(_component_van_stepper, {
        modelValue: $setup.cartList[item.id].count,
        "onUpdate:modelValue": $event => $setup.cartList[item.id].count = $event,
        step: item.step_no,
        min: "0",
        name: item.id,
        onChange: $setup.editCart,
        onMinus: $event => $setup.delCart(item.id, item.less_no),
        "disable-input": ""
      }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "name", "onChange", "onMinus"])])) : (_openBlock(), _createElementBlock("dd", _hoisted_8, [_createElementVNode("button", {
        onClick: $event => $setup.addCart(item.id, item.less_no)
      }, "加入购物车", 8, _hoisted_9)]))])])]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])])) : _createCommentVNode("", true)])], 64);
}